<template>
  <input :id="id" type="hidden" :name="name" :value="chosenVariant ? chosenVariant : null" />
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    name: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    productMaster: {
      type: String,
      default: "",
    }
  },
  computed: {
    ...mapGetters({
      chosenVariant: "productShow/chosenVariant",
    }),
  },
};
</script>
